import React from 'react';
const initialStatus = 'undetermined';
export const AuthContext = React.createContext([
    { status: initialStatus, userData: null, unauthenticatedUri: null },
    () => {
        // Will be set by the provider.
    },
]);
